import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Question, ClassMapper } from 'mapfre-auditlib';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {


  className = 'QuestionService';

  constructor(private http: HttpClient, private translateService: TranslateService) {
  }

  getAllQuestions(): Observable<Question[]> {
    return this.http.get<Question[]>(environment.base_URL + "/questions").pipe(map(res => {
      return ClassMapper.fromJSONArray(res, Question, this.translateService);
    }))
  }

  newQuestion(newQuestion: any) {
    return this.http.post(environment.base_URL + "/questions", newQuestion);
  }

  updateQuestion(editedQuestion, id) {
    return this.http.put(environment.base_URL + `/questions/${id}`, editedQuestion)
  }

}
